import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { routes } from "./config";
import { AppRoute } from "../types/routes";
import { AuthUser } from "../types/auth-types";

interface AppRoutesProps {
  user: AuthUser | null;
  onAuthSuccess: (user: AuthUser) => void;
  onLogout: () => void;
}

const AppRoutes: React.FC<AppRoutesProps> = ({ user, onAuthSuccess, onLogout }) => {
  return (
    <Routes>
      {routes.map((route) => {
        const Component = route.component;
        const element = <Component user={user} onAuthSuccess={onAuthSuccess} onLogout={onLogout} {...route.props} />;

        return (
          <Route
            key={route.path}
            path={route.path}
            element={
              route.protected ? (
                user ? (
                  element
                ) : (
                  <Navigate to={AppRoute.LOGIN} replace />
                )
              ) : user &&
                (route.path === AppRoute.LOGIN ||
                  route.path === AppRoute.SIGNUP) ? (
                <Navigate to={AppRoute.HOME} replace />
              ) : (
                element
              )
            }
          />
        );
      })}
      <Route path="*" element={<Navigate to={user ? AppRoute.HOME : AppRoute.LOGIN} replace />} />
    </Routes>
  );
};

export default AppRoutes;
